import React from "react";
import FormField from "./FormField";

export default class FormControl extends FormField {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.state.type = "text";
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    handleChange(event) {
        super.handleChange(event);
        if (this.props.onChange) {
            this.props.onChange(event)
        }
    }

    /*handleInput(event) {
        super.handleInput(event);
        if (this.props.onInput) {
            this.props.onInput(event)
        }
    }*/

    handleBlur(event) {
        super.handleBlur(event);
        if (this.props.onBlur) {
            this.props.onBlur(event)
        }
    }

    render() {
        var className = `form-control ${this.props.className ? this.props.className : ""} ${this.state.type === "color" ? "form-control-color" : ""} ${this.props.sizing ? "form-control-" + this.props.sizing : ""}`;

        var render =
            <input
                type={this.state.type}
                {...this.getProps(this.props)}
                ref={this.state.ref}
                className={className}
                onBlur={this.handleBlur}
                onChange={this.handleChange}
            />;

        return this.getRenderFormControl(render);
    }
}